module.exports = __webpack_public_path__ + "static/media/5.0a8f6ad1.jpg";